import { EIP20 } from '../EIP20'
import { ChainId } from '../../ChainId'

export const RopstenEIP20 = [
  new EIP20(ChainId.ETH_ROPSTEN, '0xaD6D458402F60fD3Bd25163575031ACDce07538D', 18, 'DAI', 'Dai Stablecoin')
]
